"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentErrorHandler = void 0;

var data_protector_1 = require("data-protector");

var PaymentErrorHandler =
/** @class */
function () {
  function PaymentErrorHandler() {// Empty constructor
  }

  PaymentErrorHandler.prototype.logProcessingError = function (e, paymentClient, paymentCommunicator) {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        Promise.resolve().then(function () {
          return __awaiter(_this, void 0, void 0, function () {
            var clonedClient;

            var _a, _b, _c;

            return __generator(this, function (_d) {
              switch (_d.label) {
                case 0:
                  clonedClient = Object.assign({}, paymentClient); // Mask payment info

                  return [4
                  /*yield*/
                  , this.maskCreditCardInfo(clonedClient.creditCardInfo)];

                case 1:
                  // Mask payment info
                  _d.sent();

                  return [4
                  /*yield*/
                  , this.maskACHInfo(clonedClient.achInfo)];

                case 2:
                  _d.sent();

                  return [4
                  /*yield*/
                  , this.maskECheckInfo(clonedClient.eCheckInfo)];

                case 3:
                  _d.sent();

                  return [4
                  /*yield*/
                  , this.maskEPaperTokenInfo(clonedClient.ePaperTokenInfo)];

                case 4:
                  _d.sent(); // Mask billing contact info


                  return [4
                  /*yield*/
                  , this.maskBillingContactInfo(clonedClient.billingContactInfo)];

                case 5:
                  // Mask billing contact info
                  _d.sent(); // Remove paymentCommunicator from session
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  //@ts-ignore


                  (_a = clonedClient.session) === null || _a === void 0 ? true : delete _a.paymentCommunicator; // console.log(JSON.stringify(e));

                  return [4
                  /*yield*/
                  , paymentCommunicator.logErrorDetails(e, clonedClient, (_c = (_b = paymentClient.session) === null || _b === void 0 ? void 0 : _b.vendorSessionInfo) === null || _c === void 0 ? void 0 : _c.billingToken)];

                case 6:
                  // console.log(JSON.stringify(e));
                  _d.sent();

                  return [2
                  /*return*/
                  ];
              }
            });
          });
        });
        return [2
        /*return*/
        ];
      });
    });
  };

  PaymentErrorHandler.prototype.logLegacyProcessingError = function (e, paymentClient, paymentCommunicator) {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        Promise.resolve().then(function () {
          return __awaiter(_this, void 0, void 0, function () {
            var clonedClient;

            var _a;

            return __generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  clonedClient = Object.assign({}, paymentClient); // Mask payment info

                  return [4
                  /*yield*/
                  , this.maskCreditCardInfo(clonedClient.creditCardInfo)];

                case 1:
                  // Mask payment info
                  _b.sent();

                  return [4
                  /*yield*/
                  , this.maskACHInfo(clonedClient.achInfo)];

                case 2:
                  _b.sent();

                  return [4
                  /*yield*/
                  , this.maskECheckInfo(clonedClient.eCheckInfo)];

                case 3:
                  _b.sent();

                  return [4
                  /*yield*/
                  , this.maskEPaperTokenInfo(clonedClient.ePaperTokenInfo)];

                case 4:
                  _b.sent(); // Mask billing contact info


                  return [4
                  /*yield*/
                  , this.maskBillingContactInfo(clonedClient.legacySession.billingContact)];

                case 5:
                  // Mask billing contact info
                  _b.sent(); // Remove paymentCommunicator from session
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  //@ts-ignore


                  (_a = clonedClient.legacySession) === null || _a === void 0 ? true : delete _a.paymentCommunicator; // console.log(JSON.stringify(e));

                  return [4
                  /*yield*/
                  , paymentCommunicator.logErrorDetails(e, clonedClient)];

                case 6:
                  // console.log(JSON.stringify(e));
                  _b.sent();

                  return [2
                  /*return*/
                  ];
              }
            });
          });
        });
        return [2
        /*return*/
        ];
      });
    });
  };

  PaymentErrorHandler.prototype.maskCreditCardInfo = function (creditCardInfo) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (creditCardInfo) {
          // TODO: Use lookbehind & lookahead instead of polyfill
          // creditCardInfo.number = creditCardInfo.number.replace(
          //     /(?<=[0-9]{6})[0-9](?=[0-9]{4})/g,
          //     "*"
          // );
          creditCardInfo.number = this.replaceAllButFirstSixAndLastFourDigits(creditCardInfo.number);
          creditCardInfo.securityCode = data_protector_1.DataProtector.protect(creditCardInfo.securityCode);
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  PaymentErrorHandler.prototype.maskACHInfo = function (achInfo) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (achInfo) {
          // achInfo.bankAccountNumber = achInfo.bankAccountNumber.replace(
          //     /[0-9](?=([0-9]{4}))/g,
          //     "*"
          // );
          // achInfo.bankRoutingNumber = achInfo.bankRoutingNumber.replace(
          //     /[0-9](?=([0-9]{4}))/g,
          //     "*"
          // );
          achInfo.bankAccountNumber = this.replaceAllButLastFourDigits(achInfo.bankAccountNumber);
          achInfo.bankRoutingNumber = this.replaceAllButLastFourDigits(achInfo.bankRoutingNumber);
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  PaymentErrorHandler.prototype.maskECheckInfo = function (eCheckInfo) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (eCheckInfo) {
          // eCheckInfo.bankAccountNumber = eCheckInfo.bankAccountNumber.replace(
          //     /[0-9](?=([0-9]{4}))/g,
          //     "*"
          // );
          // eCheckInfo.bankRoutingNumber = eCheckInfo.bankRoutingNumber.replace(
          //     /[0-9](?=([0-9]{4}))/g,
          //     "*"
          // );
          // eCheckInfo.checkNumber = eCheckInfo.checkNumber.replace(
          //     /[0-9](?=([0-9]{4}))/g,
          //     "*"
          // );
          // eCheckInfo.driverLicenseNumber = eCheckInfo.driverLicenseNumber.replace(
          //     /(?<=.).*(?=.)/g,
          //     "*"
          // );
          eCheckInfo.bankAccountNumber = this.replaceAllButLastFourDigits(eCheckInfo.bankAccountNumber);
          eCheckInfo.bankRoutingNumber = this.replaceAllButLastFourDigits(eCheckInfo.bankRoutingNumber);
          eCheckInfo.checkNumber = this.replaceAllButLastFourDigits(eCheckInfo.checkNumber);
          eCheckInfo.driverLicenseNumber = this.replaceAllButFirstAndLastCharacters(eCheckInfo.driverLicenseNumber);
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  PaymentErrorHandler.prototype.maskEPaperTokenInfo = function (ePaperTokenInfo) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (ePaperTokenInfo) {
          // ePaperTokenInfo.ePaperToken = ePaperTokenInfo.ePaperToken.replace(
          //     /[0-9](?=([0-9]{4}))/g,
          //     "*"
          // );
          ePaperTokenInfo.ePaperToken = this.replaceAllButLastFourDigits(ePaperTokenInfo.ePaperToken);
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  PaymentErrorHandler.prototype.maskBillingContactInfo = function (billingContactInfo) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (billingContactInfo) {
          if (billingContactInfo.name) {
            billingContactInfo.name = data_protector_1.DataProtector.protect(billingContactInfo.name);
          }

          if (billingContactInfo.address) {
            billingContactInfo.address.address1 = data_protector_1.DataProtector.protect(billingContactInfo.address.address1);
            billingContactInfo.address.address2 = data_protector_1.DataProtector.protect(billingContactInfo.address.address2);
            billingContactInfo.address.address3 = data_protector_1.DataProtector.protect(billingContactInfo.address.address3);
            billingContactInfo.address.city = data_protector_1.DataProtector.protect(billingContactInfo.address.city);
            billingContactInfo.address.state = data_protector_1.DataProtector.protect(billingContactInfo.address.state);
          }

          if (billingContactInfo.contactInfo) {
            billingContactInfo.contactInfo = data_protector_1.DataProtector.protect(billingContactInfo.contactInfo);
          }
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  PaymentErrorHandler.prototype.replaceAllButFirstSixAndLastFourDigits = function (input) {
    if (!input || input.length < 10) {
      return input;
    }

    var firstSix = input.slice(0, 6);
    var lastFour = input.slice(-4);
    return firstSix + input.slice(6, -4).replace(/[0-9]/g, "*") + lastFour;
  };

  PaymentErrorHandler.prototype.replaceAllButLastFourDigits = function (input) {
    if (!input || input.length < 4) {
      return input;
    }

    var lastFour = input.slice(-4);
    return input.slice(0, -4).replace(/[0-9]/g, "*") + lastFour;
  };

  PaymentErrorHandler.prototype.replaceAllButFirstAndLastCharacters = function (input) {
    if (!input || input.length < 2) {
      return input;
    }

    var first = input.slice(0, 1);
    var last = input.slice(-1);
    return first + input.slice(1, -1).replace(/[0-9]/g, "*") + last;
  };

  return PaymentErrorHandler;
}();

exports.PaymentErrorHandler = PaymentErrorHandler;


// WEBPACK FOOTER //
// ./node_modules/@backoffice/fast-payments-client-js-sdk/build/src/PaymentClient/Session/PaymentErrorHandler.js